export default __webpack_public_path__ + "media/color/gxs-2869f951.svg";